// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"style_confirmation-modal__IE9Xr","confirmationModal":"style_confirmation-modal__IE9Xr"};